import { Radio as NBRadio } from 'native-base';

import type { IRadioComponentType } from './Radio.types';

const RadioTemp: any = NBRadio;
RadioTemp.Group = NBRadio.Group;

const Radio = RadioTemp as IRadioComponentType;

export { Radio };
export type { IRadioProps, IRadioGroupProps } from 'native-base';
